import t from"react";import{stringToSlug as o}from"../../../../../utils/helpers.js";import{Typography as r}from"./styles.js";const e=({options:e})=>t.createElement(r,{id:e.anchor?o(e.anchor):void 0,"data-toc":e.in_toc?o(e.text):void 0,variant:"h4"},e.text);export{e as Headline};
//# sourceMappingURL=Headline.js.map
